import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-03cdee26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "date",
  class: "small-label"
}, "Организация", -1))
const _hoisted_3 = { class: "flex flex-col m-t-8" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "small-label"
}, "Департамент", -1))
const _hoisted_5 = { class: "flex flex-col m-t-8" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "small-label"
}, "Роль", -1))
const _hoisted_7 = { class: "toggle-row m-t-8" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "include_demo",
  class: "small-label"
}, " Включать в список демо-аккаунты ", -1))

import { ref, onMounted, watch } from "vue";

import MultiSelect from "primevue/multiselect";
import InputSwitch from "primevue/inputswitch";
import CatalogDataBaseInput from "@/widgets/forms/CatalogDataBaseInput.vue";
import ListFilterForm from "@/widgets/forms/ListFilterForm.vue";

import { useOrganizationsDictionaryStore } from "@/store/catalog_data/organizations";
import { Department } from "@/store/dictionaries/organizations";


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersFilterForm',
  props: {
    isFilterEnabled: { type: Boolean }
  },
  emits: ["toggleFilter", "setFilter"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const orgDictionaryStore = useOrganizationsDictionaryStore();
const departments = ref([] as Department[]);
const localFilter = ref<any>(null);

const initialFilter = {
  include_demo: false,
  organization: [] as number[],
  department: [] as number[],
  role: [] as number[],
};

const setDepartments = () => {
  departments.value = [];
  if (localFilter.value && localFilter.value.organization) {
    localFilter.value.organization.forEach((item: number) => {
      const foundItem = orgDictionaryStore.itemList.find(
        (itemDict) => itemDict.id === item,
      );
      if (foundItem) {
        departments.value = [...departments.value, ...foundItem.departments];
      }
    });
  }
};

const getRoles = () => {
  let roles: any[] = [];
  if (localFilter.value && localFilter.value.department && departments.value) {
    departments.value.forEach((item) => {
      if (localFilter.value.department.includes(item.id) && item.roles) {
        roles = [...roles, ...item.roles];
      }
    });
  }
  return roles;
};

const setParentFilter = (filter: any, isSetted: boolean) => {
  emits("setFilter", filter, isSetted);
};

const setLocalFilter = (filter: any) => {
  localFilter.value = filter;
  setDepartments();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListFilterForm, {
    "is-filter-enabled": props.isFilterEnabled,
    "initial-filter": initialFilter,
    "has-local": true,
    onToggleFilter: _cache[0] || (_cache[0] = ($event: any) => (emits('toggleFilter'))),
    onSetFilter: setParentFilter,
    onUpdateLocalFilter: setLocalFilter
  }, {
    fields: _withCtx((slotProps) => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(CatalogDataBaseInput, {
          useIdOnly: true,
          selectType: "organization",
          isSegmentSetted: false,
          modelValue: slotProps.filter.organization,
          "onUpdate:modelValue": 
            ($event) => {
              slotProps.filter.organization = $event;
              slotProps.filter.department = [];
              slotProps.filter.role = [];
            }
          
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_unref(MultiSelect), {
          modelValue: slotProps.filter.department,
          "onUpdate:modelValue": [($event: any) => ((slotProps.filter.department) = $event), 
            ($event) => {
              slotProps.filter.role = [];
            }
          ],
          optionLabel: "name",
          options: departments.value,
          optionValue: "id",
          disabled: slotProps.filter.organization.length == 0,
          placeholder: "Выберите значение",
          filter: "",
          showClear: ""
        }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_unref(MultiSelect), {
          modelValue: slotProps.filter.role,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.role) = $event),
          optionLabel: "name",
          options: getRoles(),
          optionValue: "id",
          disabled: 
            slotProps.filter.department.length == 0 ||
            slotProps.filter.organization.length == 0
          ,
          placeholder: "Выберите значение",
          filter: "",
          showClear: ""
        }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_unref(InputSwitch), {
          modelValue: slotProps.filter.include_demo,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.include_demo) = $event),
          inputId: "include_demo"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["is-filter-enabled"]))
}
}

})